import { render, staticRenderFns } from "./AcquirerForm.vue?vue&type=template&id=58ad9526&scoped=true&"
import script from "./AcquirerForm.vue?vue&type=script&lang=js&"
export * from "./AcquirerForm.vue?vue&type=script&lang=js&"
import style0 from "./AcquirerForm.vue?vue&type=style&index=0&id=58ad9526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ad9526",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
